export default __webpack_public_path__ + "static/media/marioVideo3.d14456e4.mov";